import React from "react";

const SvgMinus = props => <svg fill="none" viewBox="0 0 12 2" {...props}><defs /><path fill="#1A1A1A" fillRule="evenodd" d="M.688.625h10.5V1.5H.688V.625z" clipRule="evenodd" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTIgMiI+PGRlZnMvPjxwYXRoIGZpbGw9IiMxQTFBMUEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS42ODguNjI1aDEwLjVWMS41SC42ODhWLjYyNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgMinus as ReactComponent };